import { CLIENT_SENTRY_IGNORE_RULES } from '@/shared/utils/sentry/clientIgnoreRules/rules';
import { ClientSentryEventContext } from '@/shared/utils/sentry/clientIgnoreRules/types';

export const shouldIgnoreClientSentryEvent = (
  context: ClientSentryEventContext
): boolean => CLIENT_SENTRY_IGNORE_RULES.some((rule) => rule.matches(context));
